<script setup>
import SMessageChargement from '@/components/global/s-message-chargement.vue'

defineEmits(['changed'])
</script>

<template>
  <v-row justify="space-between" align="center" no-gutters>
    <s-message-chargement v-if="loading">Verification de l'état de la demande</s-message-chargement>
    <v-col v-if="demandeCorrespondanteAFicheAim !== undefined">
      <v-chip>validation en cours {{ nbValidee }}/{{ nbValidationsRequises }}</v-chip>
    </v-col>
    <v-col cols="auto" v-if="demandeCorrespondanteAFicheAim !== undefined && doitValider">
      <v-row justify="end" no-gutters>
        <v-btn class="mr-2" color="info" @click="validerLaDemande"><v-icon left>mdi-check</v-icon>Valider</v-btn>
        <v-btn color="error" @click="invaliderLaDemande"><v-icon left>mdi-close</v-icon>Invalider</v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'traitement-demande-fiche-aim',
  props: {
    ficheAimId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      demandeCorrespondanteAFicheAim: undefined,
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'security/getAuthenticatedUser',
      isInRole: 'security/isInRole',
    }),
    nbValidee() {
      let count = 0
      this.demandeCorrespondanteAFicheAim.validations
        .filter((v) => !v.estAccepte)
        .forEach((v) => (count += v.accepte ? 1 : 0))
      return count
    },
    nbValidationsRequises() {
      return this.demandeCorrespondanteAFicheAim.validations.length
    },
    doitValider() {
      return this.demandeCorrespondanteAFicheAim.validations.some(
        (v) => v.authority === this.authUser.username || this.isInRole(v.authority)
      )
    },
    validationCorrespondanteAUtilisateur() {
      return this.demandeCorrespondanteAFicheAim.validations.filter(
        (v) => v.authority === this.authUser.username || this.isInRole(v.authority)
      )[0]
    },
  },
  methods: {
    ...mapActions({
      obtenirDemandeCorrespondanteAFicheAim: 'demande/obtenirDemandeCorrespondanteAFicheAim',
      validerDemande: 'demande/validerDemande',
      refuserDemande: 'demande/refuserDemande',
    }),
    validerLaDemande() {
      this.validerDemande({
        demandeId: this.demandeCorrespondanteAFicheAim.demandeId,
        validationId: this.validationCorrespondanteAUtilisateur.validationId,
      }).then(() => this.$emit('changed'))
    },
    invaliderLaDemande() {
      this.refuserDemande({
        demandeId: this.demandeCorrespondanteAFicheAim.demandeId,
        validationId: this.validationCorrespondanteAUtilisateur.validationId,
      }).then(() => this.$emit('changed'))
    },
  },
  created() {
    this.obtenirDemandeCorrespondanteAFicheAim(this.ficheAimId)
      .then((value) => (this.demandeCorrespondanteAFicheAim = value))
      .then((this.loading = false))
  },
}
</script>

<style scoped></style>
